import { curry } from 'lodash-es';

export const enrichWithConfig = curry((facetsConfig, subgroupsConfig, facets) => {
  return facets.map(facet => ({
    ...facet,
    config: facet.group ? subgroupsConfig[facet.group] : facetsConfig[facet.type],
    values: facet.group ? enrichWithConfig(facetsConfig, subgroupsConfig, facet.values) : facet.values,
  }));
});
